/**
 * One Piece TCG rarity codes (as TCGPlayer / Bandai print them) mapped to
 * human-readable names. The DB stores the lowercased Bandai abbreviation
 * (`tcgCard.ExtRarity` lowercased during staging), so we key off lowercase.
 *
 * Exhaustive across the entire TCGPlayer One Piece catalogue (cat. 68) as of
 * 2026-04: 73 groups, 6,376 cards, 9 distinct rarity codes — all listed
 * below in descending frequency.
 */
const ONE_PIECE_RARITY_NAMES: Record<string, string> = {
  c: "Common",
  uc: "Uncommon",
  r: "Rare",
  sr: "Super Rare",
  pr: "Promo",
  l: "Leader",
  "don!!": "DON!! Card",
  sec: "Secret Rare",
  tr: "Treasure Rare",
};

export interface OnePieceRarity {
  /** Human-readable display name (e.g. "Super Rare"). */
  name: string;
  /** Original Bandai abbreviation as printed on the card (e.g. "SR"). */
  abbr: string;
}

/**
 * Resolve a One Piece rarity string into a friendly name + canonical
 * abbreviation. Falls back to the raw value (uppercased) for unknown codes
 * so we never silently drop information.
 */
export function formatOnePieceRarity(raw: string): OnePieceRarity {
  const key = raw.toLowerCase().trim();
  const name = ONE_PIECE_RARITY_NAMES[key];
  const abbr = raw.toUpperCase();
  if (!name) {
    return { name: abbr, abbr };
  }
  return { name, abbr };
}
